import firebase from 'firebase/app'
import 'firebase/firestore'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const config = {
   apiKey: "AIzaSyAIctmm1THxfSzb_TmubTvZ8b98OdNxvlw",
   authDomain: "parth-jain-02.firebaseapp.com",
   projectId: "parth-jain-02",
   storageBucket: "parth-jain-02.appspot.com",
   messagingSenderId: "111656599254",
   appId: "1:111656599254:web:a94d2c131742ac72165377",
   measurementId: "G-RCVKBRDBVY"
 };


firebase.initializeApp(config);
var db = firebase.firestore();

export { db };